
import { isOutOfSpec } from '../../shared/utils/isOutOfSpec.ts';
import { ProtocolFinal, RecordDraft } from '../types/sharedTypeImpl.ts';
import { reportError } from './errorReporting.ts';


export function getNumOutOfSpec(record: RecordDraft, protocol: ProtocolFinal) {
    let numOutOfTolerance = 0;
    for (const part of record.parts) {
        for (const positionValue of part.positionValues) {
            const position = protocol.positions.find(it => it.positionNumber === positionValue.positionNumber);
            if (!position) {
                reportError(`Position ${positionValue.positionNumber} not found in protocol`);
                continue;
            }

            if (isOutOfSpec(position, positionValue)) {
                numOutOfTolerance++;
            }
        }
    }

    return numOutOfTolerance;
}
